// src/components/UserForm/useRoleOptions.js
import { useEffect, useState } from "react";
import { roleList } from "../Service/Api/role";
import useDebouncedApiCall from "./useDebouncedApiCall";

const useRoleOptions = () => {
  const { call } = useDebouncedApiCall();
  const [roleOption, setRoleOption] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await call(() => roleList());
        setRoleOption(
          res.data.map((el) => ({
            value: el.id.toString(),
            label: el.name,
          }))
        );
      } catch (e) {
        console.error("Failed to fetch roles", e);
      }
    };
    fetch();
  }, []);

  return roleOption;
};

export default useRoleOptions;
